import { render, staticRenderFns } from "./GoliaButton.vue?vue&type=template&id=fff53b82&scoped=true"
import script from "./GoliaButton.vue?vue&type=script&lang=js"
export * from "./GoliaButton.vue?vue&type=script&lang=js"
import style0 from "./GoliaButton.vue?vue&type=style&index=0&id=fff53b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff53b82",
  null
  
)

export default component.exports